import { Version } from './version';

export class ProductVersion {
  public name: string;

  constructor(private _name: string, public version: Version) {
    this.name = this._name.toLowerCase();
  }
}
